<template>
  <div v-if="page" class="content-page">
    <!-- <h3>{{ page.title }}</h3> -->
    <div v-html="page.content" class="content" />
  </div>
  <div v-else-if="status === 'loading'">Loading...</div>
  <div v-else>
    <PageNotFound />
  </div>
</template>

<script setup lang="ts">
import { useContentStore } from "@/stores/content";
import { useRoute, useRouter } from "vue-router";
// import { useSSRStore } from "@/stores/ssr";
import PageNotFound from "@/components/PageNotFound.vue";
import { useRepsStore } from "@/stores/user";
import { getConsultant } from "@/utils/reps";
import { timer } from "@paparazzi/utils/promise";
import { useHead } from "@unhead/vue";
import { computed, onMounted, ref } from "vue";

const props = defineProps<{ path: string }>();
const content = useContentStore();
const reps = useRepsStore();
const route = useRoute();
const router = useRouter();

// const ssr = useSSRStore();

const status = ref("loading");

const page = computed(() => {
  return content.pages[`/${route.params.path}`];
});

useHead({
  title: computed(() => page.value?.title || "Not found"),
  meta: computed(() => {
    return [{ name: "description", content: page.value?.description }];
  }),
});

onMounted(async () => {
  // ssr.requires('content');

  // test if the path is a consultant
  await timer(10);
  const rep = await getConsultant(props.path);
  if (rep) {
    router.push({
      name: "home",
      query: { consultantId: rep.rep_number },
    });
  }

  await content.update();

  status.value = "";
});
</script>

<style scoped>
.content-page {
  display: flex;
  max-width: var(--Max-page-widths-max-width, 1120px);
  flex-direction: column;
  align-items: center;
  gap: var(--XL, 56px);
  align-self: stretch;
}
h3 {
  color: var(--Black, #000);
  text-align: center;
  margin: 0;

  /* Heading 3 */
  font-family: Indivisible;
  font-size: 18px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  text-transform: uppercase;
}
.content {
  margin: auto;
  max-width: var(--Component-sizes-4XL, 740px);
  align-self: stretch;
  color: var(--Black, #000);
  font-family: Indivisible;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
:deep(.contact-us-page) {
  width: 610px;
}
:deep(.contact-info) {
    gap: var(--XL, 56px);
  }
  :deep(.content .page ul li) {
    text-align: left;
    list-style: revert;
  }
  :deep(.content .page ol li) {
    text-align: left;
    list-style: revert;
  }
@media (max-width: 740px) {
  .content {
    max-width: 100%;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
}
@media (max-width: 640px) {
  :deep(.contact-us-page){
    width: 100%;
  }
  :deep(.contact-info.flex-row) {
    flex-direction: column!important;
    gap: var(--XS, 16px);
  }
}
</style>
